import React, { useMemo } from "react";
import PickerInput, { PickerPropsWithoutOptions } from "../inputs/PickerInput";

interface Props extends PickerPropsWithoutOptions { }

export default function LanguagePicker({ ...PickerProps }: Props) {

    interface Option { text: string, value: string }

    const values: Option[] = [{ text: 'English', value: 'en' }, { text: 'Spanish', value: 'es' }];

    const options = useMemo(() => values.map(c => ({ id: c.value.toString(), label: c.text })), [values]);

    return <PickerInput label={'Language'} options={options} {...PickerProps} />
}
